import { render, staticRenderFns } from "./StateNumbers.vue?vue&type=template&id=68665006&scoped=true&"
import script from "./StateNumbers.vue?vue&type=script&lang=js&"
export * from "./StateNumbers.vue?vue&type=script&lang=js&"
import style0 from "./StateNumbers.vue?vue&type=style&index=0&id=68665006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68665006",
  null
  
)

export default component.exports